import { render, staticRenderFns } from "./scatterChart.vue?vue&type=template&id=278a9eb8&lang=pug"
import script from "./scatterChart.vue?vue&type=script&lang=js"
export * from "./scatterChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports